<div class="stars">
  @for (star of [0, 1, 2, 3, 4]; track $index) {
    <span class="stars__size" [class.stars__small]="starSize() === 'small'"
      ><svg
        width="27"
        height="25"
        viewBox="0 0 27 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.4 20.2016L21.3567 24.95L19.3033 15.9666L26.2333 9.80665L16.9933 9.03665L13.4 0.56665L9.80665 9.03665L0.56665 9.80665L7.62498 15.9666L5.57165 24.95L13.4 20.2016Z"
          fill="currentColor"
        />
      </svg>
    </span>
  }
</div>
